import { useEffect, useState } from "react";
import {
  ChevronUp,
  ChevronDown,
  BadgeDollarSign,
  CreditCard,
  MoreVertical,
  Eye,
  EyeOff,
  Plus,
  Minus,
} from "lucide-react";
import "./index.css";
import { Logs } from "../logs";
import { Modal, Button, Form } from "react-bootstrap";
import { fireToastMessage } from "../../toastContainer";
import { useHistory } from "react-router-dom";
import { MarketTable } from ".";
import { demoBuyStock, demoSellStock } from "../../../services/demouser";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const sampleRows = [
  ["--", "--", "--", "--"],
  ["--", "--", "--", "--"],
  ["--", "--", "--", "--"],
  ["--", "--", "--", "--"],
  ["--", "--", "--", "--"],
  ["--", "--", "--", "--"],
];

function SellBuyForm({ formData, setFormData, symbol }) {
  const [showPin, setShowPin] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleConfirm = async () => {
    console.log("Confirm button clicked"); // Debug
    setLoading(true);
    try {
      const apiData = {
        symbol: symbol,
        quantity: formData.noOfShares,
        price: formData.sharePrice,
      };

      let response;
      if (formData.tradeType === "Buy") {
        response = await demoBuyStock(apiData);
      } else {
        response = await demoSellStock(apiData);
      }

      setShowModal(false);
      fireToastMessage({
        type: "success",
        message: `${formData.tradeType} order placed successfully!`,
      });

      console.log("Order response:", response);
    } catch (error) {
      console.error("Error placing order:", error);
      fireToastMessage({
        type: "error",
        message: `Failed to place ${formData.tradeType.toLowerCase()} order. Please try again.`,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="sellbuy-wrapper">
      <div className="sellbuy-left">
        <div className="sellbuy-dropdowns flex gap-4">
          <select
            className="sellbuy-select"
            value={formData.tradeType}
            onChange={(e) => handleChange("tradeType", e.target.value)}
          >
            <option value="Buy">Buy</option>
            <option value="Sell">Sell</option>
          </select>

          <select
            className="sellbuy-select"
            value={formData.orderType}
            onChange={(e) => handleChange("orderType", e.target.value)}
          >
            <option value="Limit">Limit</option>
            <option value="Market">Market</option>
          </select>
        </div>

        <div className="sellbuy-input-group flex items-center gap-2 mt-2">
          <button
            type="button"
            onClick={() => handleChange("noOfShares", formData.noOfShares - 1)}
            className="sellbuy-incdec"
          >
            <Minus size={18} />
          </button>
          <input
            type="number"
            className="sellbuy-input"
            value={formData.noOfShares}
            onChange={(e) => handleChange("noOfShares", Number(e.target.value))}
          />
          <button
            type="button"
            onClick={() => handleChange("noOfShares", formData.noOfShares + 1)}
            className="sellbuy-incdec"
          >
            <Plus size={18} />
          </button>
        </div>

        <div className="sellbuy-values flex justify-between text-sm font-medium text-gray-700 mt-2">
          <span>Ask: 112</span>
          <span>Bid: 98</span>
        </div>

        <div className="sellbuy-input-group flex items-center gap-2 mt-2">
          <button
            type="button"
            onClick={() => handleChange("sharePrice", formData.sharePrice - 1)}
            className="sellbuy-incdec"
          >
            <Minus size={18} />
          </button>
          <input
            type="number"
            className="sellbuy-input"
            value={formData.sharePrice}
            onChange={(e) => handleChange("sharePrice", Number(e.target.value))}
          />
          <button
            type="button"
            onClick={() => handleChange("sharePrice", formData.sharePrice + 1)}
            className="sellbuy-incdec"
          >
            <Plus size={18} />
          </button>
        </div>

        <div className="sellbuy-pin flex items-center gap-2 mt-2">
          <input
            type={showPin ? "text" : "password"}
            className="sellbuy-input"
            value={formData.pin}
            onChange={(e) => handleChange("pin", e.target.value)}
          />
          <button
            type="button"
            onClick={() => setShowPin(!showPin)}
            className="sellbuy-eye-btn"
          >
            {showPin ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>

        <button
          type="button"
          className={`sellbuy-buy-btn ${
            formData?.tradeType === "Buy"
              ? "drawer-logs-buy"
              : "drawer-logs-sell"
          }`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowModal(true);
          }}
        >
          {formData?.tradeType}
        </button>
      </div>

      <div className="sellbuy-right grid-2">
        <MarketTable rows={sampleRows} title={"MBO-Market Depth By Order"} />
        <MarketTable rows={sampleRows} title={"MBO-Market Depth By Order"} />
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>
              <strong>Symbol:</strong> {symbol}
            </p>
            <p>
              <strong>Trade Type:</strong> {formData.tradeType}
            </p>
            <p>
              <strong>Quantity:</strong> {formData.noOfShares}
            </p>
            <p>
              <strong>Price:</strong> {formData.sharePrice}
            </p>
            <p>
              <strong>Order Type:</strong> {formData.orderType}
            </p>
            <p>
              <strong>Total Value:</strong>{" "}
              {(formData.noOfShares * formData.sharePrice).toFixed(2)}
            </p>
          </div>
          <p className="mt-3">
            Are you sure you want to place this{" "}
            {formData.tradeType.toLowerCase()} order?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            variant="secondary"
            onClick={() => setShowModal(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleConfirm();
            }}
            disabled={loading}
          >
            {loading ? "Processing..." : "Confirm Order"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default function CustomBottomDrawer() {
  const { id } = useParams();
  const navigate = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isVolumeModalOpen, setIsVolumeModalOpen] = useState(false);
  const [isPriceModalOpen, setIsPriceModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    noOfShares: 500,
    sharePrice: 0,
    pin: "1111",
    currency: "PKR",
    tradeType: "Buy",
    orderType: "Limit",
  });
  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    //console.log("Updated form data:", formData);
    // You can also trigger API calls or validations here
  }, [formData]);
  return (
    <div className="drawer-logs">
      {/* Toggle Button always visible */}
      <div className="drawer-logs-toolbar">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="drawer-logs-toggle-btn"
        >
          {isOpen ? <ChevronDown size={20} /> : <ChevronUp size={20} />}

          {!isOpen && (
            <div className="drawer-logs-content">
              <div className="drawer-logs-info">
                <div className="drawer-logs-title">Virtual Buying Power</div>
                <div className="drawer-logs-line">Ready: 100000</div>
                <div className="drawer-logs-line">Future: 00</div>
              </div>

              <button className="drawer-logs-btn drawer-logs-buy">
                <BadgeDollarSign size={18} />
                <span>Virtual Buy</span>
              </button>

              <div className="drawer-logs-icon">
                <CreditCard size={22} />
              </div>

              <button className="drawer-logs-btn drawer-logs-sell">
                <BadgeDollarSign size={18} />
                <span>Virtual Sell</span>
              </button>
            </div>
          )}
        </button>
      </div>

      {/* Sliding Drawer */}
      <div
        className={`drawer-logs-slide ${
          isOpen ? "drawer-logs-slide-open" : ""
        }`}
      >
        <div className="drawer-logs-content">
          <div className="drawer-logs-info">
            <div className="drawer-logs-title">Virtual Buying Power</div>
            <div className="drawer-logs-line">Ready: 100000</div>
            <div className="drawer-logs-line">Future: 00</div>
          </div>

          <button
            type="button"
            onClick={() => handleChange("tradeType", "Buy")}
            className="drawer-logs-btn drawer-logs-buy"
          >
            <BadgeDollarSign size={18} />
            <span>Virtual Buy</span>
          </button>

          <div
            style={{ cursor: "pointer" }}
            onClick={() => navigate.push("/create-account")}
            className="drawer-logs-icon"
          >
            <CreditCard size={22} />
          </div>

          <button
            type="button"
            onClick={() => handleChange("tradeType", "Sell")}
            className="drawer-logs-btn drawer-logs-sell"
          >
            <BadgeDollarSign size={18} />
            <span>Virtual Sell</span>
          </button>

          <div className="drawer-logs-menu">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="drawer-logs-menu-btn"
            >
              <MoreVertical />
            </button>
            {menuOpen && (
              <div className="drawer-logs-menu-dropdown">
                <ul>
                  <li onClick={() => navigate.push("/demo-account")}>
                    Account / Portfolio Holdings
                  </li>
                  <li>Deposit Funds</li>
                  <li onClick={() => setIsVolumeModalOpen(true)}>
                    Volume Settings
                  </li>
                  <li onClick={() => setIsPriceModalOpen(true)}>
                    Price Settings
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        <SellBuyForm
          formData={formData}
          setFormData={setFormData}
          symbol={id}
        />
        <Logs />
      </div>
      <Modal
        show={isVolumeModalOpen}
        onHide={() => setIsVolumeModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Volume Settings</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group controlId="volumeInput">
            <Form.Control
              type="number"
              value={formData.noOfShares}
              onChange={(e) =>
                setFormData({ ...formData, noOfShares: Number(e.target.value) })
              }
              min={0}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setIsVolumeModalOpen(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={() => setIsVolumeModalOpen(false)}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={isPriceModalOpen}
        onHide={() => setIsPriceModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Price Settings</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group controlId="priceInput">
            <Form.Control
              type="number"
              value={formData.input2}
              onChange={(e) =>
                setFormData({ ...formData, input2: Number(e.target.value) })
              }
              min={0}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setIsPriceModalOpen(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={() => setIsPriceModalOpen(false)}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
